<!--工单模板管理-->
<template>
	<div>
		<el-row justify=center>
			<el-col :span="1" v-for="project in dataList" :key="project.id" :offset="0" style="width:25%; margin-top:30px;">
				<el-card v-on:click="addOutMac" :body-style="{ padding: '0px'}" shadow="hover" style="width: 260px;height: 320px;">
					<div style="padding: 6px;height: 220px;">
						<div style="margin-top: 35px;text-align: center;font-size:20px;font-weight:bold;">{{project.name}}</div>
						<div style="margin: 35px; font-size:18px;">
							设备：{{project.oneVirtualDeviceNames.length}}个照明设备
						</div>
						<div style="margin: 35px; display:none;">
							<div v-for="i in project.oneVirtualDeviceNames" :key="i" style="text-align: left;"><font size="5">内机：{{i}}</font></div>
						</div>
					</div>
					<div>
						<center>
							<el-button v-on:click="delOutMac(project.id)" icon="el-icon-delete">删除</el-button>
							<el-button v-on:click="editOutMac(project)" icon="el-icon-edit">修改</el-button>
						</center>
					</div>
				</el-card>
			</el-col>
			<el-col :span="1" :offset="0" style="width:25%; margin-top:30px;">
				<el-card v-on:click="addOutMac" :body-style="{ padding: '0px', height:'360px'}" shadow="hover" style="width: 260px;height: 320px;">
					<div style="padding: 6px;height: 120px;">
						<div style="margin-top: 35px;text-align: center;"></div>
					</div>
					<div>
						<center>
							<el-button v-on:click="addOutMac" icon="el-icon-plus">新增</el-button>
						</center>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<addItemDialog @addItemSuccess="addItemSuccess" ref='addItemDialog'></addItemDialog>
	</div>
</template>

<script>
	import addItemDialog from '@/page/projectDingZhi/tiancheng/dialogs/addItemDialog.vue'
	export default {
		components: {
			addItemDialog,
		},
		props: {},
		data() {
			return {
				dataList:[],
			}
		},
		created() {
		},
		mounted() {
			this.search();
		},
		destroyed() {},
		computed: {
		},
		watch: {
		},
		methods: {
			clickItem: function(pn){
				alert(pn);
			},
			addOutMac: function() {
				this.$refs.addItemDialog.itemId = '';
				this.$refs.addItemDialog.itemName = '';
				this.$refs.addItemDialog.type = 3;
				this.$refs.addItemDialog.addTemplateShow=true
			},
			editOutMac: function(item) {
				this.$refs.addItemDialog.itemId = item.id;
				this.$refs.addItemDialog.itemName = item.name;
				this.$refs.addItemDialog.type = 3;
				this.$refs.addItemDialog.addTemplateShow=true
			},
			search() {
				this.getTemplateList()
			},
			delOutMac(id){
				this.$confirm('确认删除分摊项目?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.tcFentanApi.delDivideItem(id, respon => {
						this.search();
					})
				}).catch(() => {      
				});
			},
			getTemplateList() {
				this.$api.tcFentanApi.divideItemList(3, respon => {
					for(var i=0; i<respon.length; i++){
						respon[i].oneDeviceNos = JSON.parse(respon[i].oneDeviceNos);
						if(respon[i].twoDeviceNos != null){
							respon[i].twoDeviceNos = JSON.parse(respon[i].twoDeviceNos);
						}
					}
				 	this.total = respon.length;
					this.dataList = respon;
				})
			},
			addItemSuccess(){
				this.search();
			}
		}
	}
</script>